import Table from 'components/base/Table';
import useRows from './useTableLayout/useRows';
import useCols from './useTableLayout/useCols';
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import { StyledFilterSetsTable } from '../FilterSetsList.style';

const FilterSetsTable = ({
  Context,
  listHandlers,
  listFilters,
  filteredList
}) => {
  const cols = useCols({ type: listFilters?.type });
  const rows = useRows({
    Context,
    data: filteredList,
    listHandlers
  });

  return (
    <StyledFilterSetsTable>
      <TableNoLeftRightBorders>
        <Table
          data={rows}
          columns={cols}
          allowEmptyData={true}
          onRowClick={({ filterSet }) =>
            listHandlers?.onSelectFilterSet(filterSet)
          }
          defaultSortBy={{ key: 'filterSet.name', order: 'asc' }}
          withStickyHeader
        />
      </TableNoLeftRightBorders>
    </StyledFilterSetsTable>
  );
};

export default FilterSetsTable;
